import Event from '../../core/Event';

export default class EstimationSafeDraftFailed extends Event {
    public static type = 'EstimationSafeDraftFailed';

    constructor() {
        super(EstimationSafeDraftFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationSafeDraftFailed.ts